import { render, staticRenderFns } from "./detailAside.vue?vue&type=template&id=35185b71&"
import script from "./detailAside.vue?vue&type=script&lang=js&"
export * from "./detailAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports